import { render } from "./PaywallABTest.vue?vue&type=template&id=7e74fe8c&scoped=true"
import script from "./PaywallABTest.vue?vue&type=script&lang=js"
export * from "./PaywallABTest.vue?vue&type=script&lang=js"

import "./PaywallABTest.vue?vue&type=style&index=0&id=7e74fe8c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\StrinGent\\Desktop\\Robo-FullStack\\FrontEnd\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e74fe8c"]])

export default __exports__